import { ROLLLIST } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppNoApiAction, AppAction, BaseAsyncReducerState } from "../../types";

export interface RollListResponse extends BaseAsyncReducerState {
    results: Array<string>
}

// Define an initial state value for the app
const initialState: RollListResponse  = {
    loading: false,
    error: false,
    results: []
}


function RollListReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case ROLLLIST.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case ROLLLIST.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false

            }
        case ROLLLIST.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case ROLLLIST.RESET:
            return {
                ...state,
                loading: false,
                error: payload,
                results: {}
            };
        default:
            return state
        }
}

export default RollListReducer;